// extracted by mini-css-extract-plugin
export default {"input":"styles_input__0LvLG","inputLabel":"styles_inputLabel__tV2gV","inputLabelText":"styles_inputLabelText__Q7EhL","inputField":"styles_inputField__iQQOE"};